<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>

<vb-ui-typeahead-angular class="theme-header-txt" [typeaheadCfg]="searchTypeaheadCfg" [value]="SearchHeaderService.searchQuery" (onSubmit)="submitMediaSearch($event.value)">
</vb-ui-typeahead-angular>
